
(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  function init(root) {
  const cards = root.querySelectorAll('#overview.fudge-overview-inverted .fudge-banner, #overview.fudge-overview-inverted .fudge-overview-feature-card');
  cards.forEach(card => {
    if (initialized.has(card)) return;
    initialized.add(card);
    let frame = 0;
    card.addEventListener('pointermove', event => {
      if (reducedMotion.matches || event.pointerType !== 'mouse') return;
      cancelAnimationFrame(frame);
      const x = event.clientX;
      const y = event.clientY;
      frame = requestAnimationFrame(() => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--glass-x', `${Math.max(8, Math.min(92, (x - rect.left) / rect.width * 100))}%`);
        card.style.setProperty('--glass-y', `${Math.max(0, Math.min(100, (y - rect.top) / rect.height * 100))}%`);
      });
    });
    card.addEventListener('pointerleave', () => {
      cancelAnimationFrame(frame);
      card.style.removeProperty('--glass-x');
      card.style.removeProperty('--glass-y');
    });
  });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
